/**
 * Saudi / GCC Iqama (Residency Permit) format validator.
 *
 * Phase 03 Plan 03-06 Task 1 (EMP-07). Jordan's Residency Permit format
 * follows the same 10-digit convention with a leading "2" discriminator
 * (Jordan MoI uses this prefix for non-Jordanian national residency cards;
 * Saudi Iqamas historically use the same shape).
 *
 * Format contract (03-RESEARCH §D-10):
 *   - Exactly 10 digits
 *   - Leading digit MUST be "2" (residency class discriminator)
 *
 * Rejects: non-numeric, 9-digit, 11-digit, leading-1 (that's a Jordanian
 * citizen NID — use `jordanNidSchema` instead).
 *
 * MUST-test per project conventions §Testing Philosophy — ID validators are
 * data-integrity critical.
 */
import { z } from "zod";

/** `^2\d{9}$` — 10 digits, first digit MUST be "2". */
export const IQAMA_PATTERN = /^2\d{9}$/;

export const iqamaSchema = z.string().regex(IQAMA_PATTERN, {
  message: "Residency permit ID must be exactly 10 digits starting with 2",
});

export type Iqama = z.infer<typeof iqamaSchema>;
